import { Phone } from "lucide-react";
import { PageHeader } from "@/components/common/PageHeader";
import { Reveal } from "@/components/common/Reveal";
import { ServiceCard } from "@/components/common/ServiceCard";
import { Button } from "@/components/ui/button";
import { business, services } from "@/data/site";

export default function Services() {
  return (
    <div>
      <PageHeader
        eyebrow="Services"
        title="Delivery & repair for every mobility device"
        description="Powered or non-powered, big or small — if it helps you move, we can deliver it, set it up, and keep it running. Choose a category to see the details and the brands we service."
      >
        <Button asChild variant="brand" size="lg">
          <a href={business.phoneHref}><Phone className="h-4 w-4" /> Call {business.phone}</a>
        </Button>
      </PageHeader>

      <section className="section-py">
        <div className="mx-auto max-w-7xl container-px">
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {services.map((s, i) => (
              <Reveal key={s.slug} delay={(i % 3) * 0.06}>
                <ServiceCard service={s} />
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
